import { NavLink , useLocation} from "react-router-dom";
import { useContext, useState } from "react";
import Contextapi from "../../context-api/createContext";
import classNames from 'classnames';
import { CgProfile } from "react-icons/cg";
import { HomeIcon, LoadBoardIcon , CreditIcon,FundingIcon , AccountIcon , DashboardAnalyticsIcon, LogoutIcon, CopyIcon, EmailIcon, PhoneIcon, UsdotIcon, ToggleIcon } from "../svg/mainContainerIcons";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect} from "react";
import { baseUrl } from "../../utils.jsx/baseUrl";
import axios from "axios";

export default function Sidebar() {
    //  const { isnavbar } = useContext(Contextapi);
  const useriogo = sessionStorage.getItem('logo');
  const userType = sessionStorage.getItem('user_type');
  const comId = sessionStorage.getItem('comId');
  const navigate = useNavigate()
  const [expanded , setExpanded] = useState(false);
  const [data , setData] = useState([]);
  const [loaderflag, setLoaderFlag] = useState(false);
  const [isverified, setIsverified] = useState(false);
  const token = sessionStorage.getItem('token');
  
   const location = useLocation();

   useEffect(() =>{
(async () => {
      setLoaderFlag(true);
      try {
        const url = `${baseUrl.url}/company/id/${comId}`;
        const responce = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("company data in sidebar" , responce.data.record)
        setData(responce.data.record);
        setLoaderFlag(false);
      } catch (error) {
        console.log(error);
        setLoaderFlag(false);
      }
    })();
   },[])
  // const location = useLocation().pathname;
  // const [active , setActive] = useState("home")
  const lists = [{
                      id : "home",
                       label: 'Home',
                       to : "/",
                       icon : HomeIcon 
                     },{
                       id : "credit",
                       label: 'Credit',
                       to: '/credit',
                      //  to : "#",
                       icon : CreditIcon 
                     }, {
                       id : "funding",
                       label: 'Funding',
                       to: '/funding',
                      //  to : "#",
                        icon : FundingIcon
                     }, {
                       id : "account",
                       label: 'Account',
                       to: '/account',
                      //  to : "#",
                        icon : AccountIcon 
                     },
                     {
                       id : "loadboard",
                       label: 'Load Board',
                       to: '/loadboard',
                      //  to : "#",
                        icon : LoadBoardIcon 
                     },
                    //  {
                    //    id : "dashboardAnalytics",
                    //    label: 'Dashboard Analytics',
                    //    to : '/dashboard-analytics',
                    //   //  to : "#",
                    //     icon : DashboardAnalyticsIcon 
                    //  },
                    //   {
                    //    id : "dashboard",
                    //    label: 'Dashboard',
                    //    to : '/dashboard',
                    //   //  to : "#",
                    //     icon : DashboardAnalyticsIcon 
                    //  }
                   ]

 const logout = () => {
   console.log("logout called")
    toast.success('Logout successful', {
      autoClose: 500,
      pauseOnHover: false,
    });
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('sid');
    sessionStorage.removeItem('comId');
    sessionStorage.removeItem('logo');

    setTimeout(() => {
      navigate('/login');
    }, 1000);
  };
                   

    return (
      <div className="flex flex-col justify-between h-screen">
      {/* Top Section (Logo + Menu) */}
      <div className="mx-8">
        {/* Logo */}
        <div className="cursor-pointer flex justify-center my-10">
          <img src="images/singlogo.png" alt="logo" className="h-22 w-32 bg-gray-700" />
        </div>

        {/* Nav Links */}
        <div className="flex flex-col gap-6">
          {lists.map(({ id, label, to, icon: Icon }) => {
            const isDisabled = userType === 'free' && label !== 'Home' && label !== 'Load Board';
             const isActive = location.pathname === to;
            return (
              <NavLink
                key={id}
                to={isDisabled ? '#' : to}
                className={`
                  flex items-center gap-2 p-2 rounded-lg
                  ${isDisabled ? "text-gray-400 cursor-not-allowed" :
                    isActive ? "navBg text-[#258CFB]" : "text-black bg-white"}
                `}
                onClick={(e) => {
                  if (isDisabled) {
                    e.preventDefault();
                  } 
                  // else {
                  //   setActive(id);
                  // }
                }}
              >
                <Icon active={isActive} disabled={isDisabled} />
                {label}
              </NavLink>
            );
          })}
        </div>
      </div>

      {/* Bottom Section (Logout) */}
      <div>
{!expanded && (
<div className="flex mx-4 my-4 flex-row gap-2 px-2 py-1  rounded-xl shadow-sm cursor-pointer items-center" 
 style = {{
  transition: "all 0.6s ease",
   boxShadow: "0 0 1px 1px rgba(203, 213, 225, 1)",
  overflow: "hidden"
}}
onClick = {() => setExpanded(!expanded)}>
      <div className="max-w-[40px] h-[40px] rounded-[30%] overflow-hidden cursor-pointer "
      //  onClick={() => logout()}
       >  {useriogo ? <img src={useriogo} alt="images" className="min-w-full min-h-full w-full scale-100" /> : <CgProfile className=" w-full h-full text-opacity-[.4] text-black min-w-full" />}
        {/* <LogoutIcon /> */}
    
      </div>
      {loaderflag ? (
  <div className="animate-pulse flex flex-col gap-1">
    <div className="h-3 w-24 bg-gray-300 rounded"></div>
    <div className="h-3 w-36 bg-gray-200 rounded"></div>
  </div>
) :
      <div> 
         <div className="flex flex-row font-bold text-[14px]">{data.owner_name} <br /></div>
          <div className="flex flex-row text-[12px] text-gray-400">{data.email} <br /></div>
          </div>
    }
          <div className="justify-right ml-auto">
             <ToggleIcon />
          </div>
      </div>
)}

      {expanded && (
   
<div
key="open" className="mx-4 my-4 cursor-pointer shadow-lg overflow-hidden rounded-xl" 
 style = {{
  // transition: "all 0.6s ease",
  //  boxShadow: "0 0 1px 1px rgba(203, 213, 225, 1)",
  overflow: "hidden"
}}
// initial={{ opacity: 0, y: 8 }}
// animate={{ opacity: 1, y: 0 }}
// exit={{ opacity: 0, y: 8 }}
// transition={{ duration: 0.2 }}
>
<div
style={{
border: "1px solid rgba(203, 213, 225, 1)",
borderRadius: 12,
padding: 10,
background: "white",
overflow : "hidden"
}}
>
<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
<div style={{ width: 35, height: 35, borderRadius: 8, background: "gray" , rounded : "30%" , overflow : "hidden" }}>
{useriogo ? <img src={useriogo} alt="images" className="min-w-full min-h-full w-full scale-100" /> : <CgProfile className=" w-full h-full text-opacity-[.4] text-black min-w-full" />}
</div>
<div style={{ flex: 1 }}>
<div style={{ fontWeight: 600 , fontSize :"14px" }}>{data.owner_name}</div>
<div style={{ fontSize: 12, color: "gray" }}>Active company</div>
</div>
<button onClick={() => setExpanded(false)} style={{ border: "none"}} className="hover:bg-gray-200 p-2 rounded-lg">
{/* <ChevronRight size={18} /> */}<ToggleIcon />
</button>
</div>


<hr style={{ margin: "10px 0" }} />


<ProfileRow icon={<EmailIcon />} label="Email" value={data.email} />
<ProfileRow icon={<PhoneIcon />} label="Phone" value={data.phone} />
<ProfileRow icon={<UsdotIcon />} label="USDOT" value={data.usdot} copyable />
</div>
</div>
        
    // <div className = "flex flex-col gap-4 px-2 py-2  border border-b-1 border-l-1 border-r-1 bg-gray-100 border-t-0  bg-white shadow-lg  mb-6 ">
    //       <div className="flex flex-row">{data.owner_name} <br /></div>
    //       <div className="flex flex-row">{data.email} <br /></div>
    //       <div className="flex flex-row">+{data.phone} <br /></div>
    //       {/* <div className="flex flex-row">{data.usdot} <br /></div> */}
    //     </div>
      )}
       <div className="border border-gray-200 border-1"></div>
      <div className="flex mx-8 text-[#ff0000ff] items-center gap-2 p-2 mb-6 cursor-pointer" onClick={() => logout()}>
        <LogoutIcon /> Logout
      </div>
    </div>
    </div>
  );
}


function ProfileRow({ icon, label, value, copyable }) {
  const [copied, setCopied] = useState(false);
const handleCopy = () => {
  navigator.clipboard?.writeText(value);
   setCopied(true);
setTimeout(() => setCopied(false), 1500);
}
return (
<div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "5px 0" , border : "1px solid #cfdae6ff" , borderRadius : "8px" , padding : "8px" , margin : "10px 0px"}}>
<span>{icon}</span>
<div style={{ flex: 1 }}>
<div style={{ fontSize: 10, color: "gray", textTransform: "uppercase" }}>{label}</div>
<div style={{ fontSize: 13 }}>{value}</div>
</div>
{copyable && (
<button onClick={handleCopy} style={{ background: "none", border: "none", cursor: "pointer" , position: "relative"}}>
<CopyIcon />

{copied && (
<span
style={{
position: "absolute",
top: -20,
right: 0,
background: "#22c55e",
color: "white",
borderRadius: 4,
padding: "2px 6px",
fontSize: 10,
}}
>
Copied!
</span>
)}
</button>
)}
</div>
);
}